import * as React from 'react';
import { ArrowRoundForwardIcon, Greyscale } from 'glints-aries';
import { Neutral } from 'glints-aries/lib/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';

import { useEmployersURL } from 'src/common/hooks';

import { getTalentHubLandingLinks } from '../constants';
import { AiAgentsArt, EmployerArt, TalentArt } from './AudienceArt';
import * as Styled from './AudienceCards.sc';

export const AudienceCards: React.FC = () => {
  const talentHubLinks = getTalentHubLandingLinks(useEmployersURL());

  return (
    <Styled.Section>
      <Styled.Inner>
        <Styled.Grid>
          <Styled.Card audience="talent">
            <Styled.Art audience="talent">
              <TalentArt />
            </Styled.Art>
            <Styled.Body>
              <FormattedMessage
                id="landing-sg.audience.talent.title"
                defaultMessage="I'm looking for a job"
                tagName={Styled.Title}
              />
              <FormattedMessage
                id="landing-global.audience.talent.description"
                defaultMessage="Create your profile and apply to roles that match your skills and what you're looking for."
                tagName={Styled.Description}
              />
              <Styled.Cta audience="talent" href={talentHubLinks.singaporeJobs}>
                <FormattedMessage
                  id="landing-sg.audience.talent.cta"
                  defaultMessage="Explore Jobs"
                  tagName="span"
                />
                <ArrowRoundForwardIcon color={Greyscale.white} />
              </Styled.Cta>
            </Styled.Body>
          </Styled.Card>

          <Styled.Card audience="employer">
            <Styled.Art audience="employer">
              <EmployerArt />
            </Styled.Art>
            <Styled.Body>
              <FormattedMessage
                id="landing-sg.audience.employer.title"
                defaultMessage="I'm hiring talent"
                tagName={Styled.Title}
              />
              <FormattedMessage
                id="landing-global.audience.employer.description"
                defaultMessage="Post a role in minutes, or hand the whole thing to us. We cover sourcing, payroll and compliance in 150+ countries."
                tagName={Styled.Description}
              />
              <Styled.Cta audience="employer" href={talentHubLinks.hire}>
                <FormattedMessage
                  id="landing-sg.audience.employer.cta"
                  defaultMessage="Start Hiring"
                  tagName="span"
                />
                <ArrowRoundForwardIcon color={Neutral.B18} />
              </Styled.Cta>
            </Styled.Body>
          </Styled.Card>

          <Styled.Card audience="ai">
            <Styled.Art audience="ai">
              <AiAgentsArt />
            </Styled.Art>
            <Styled.Body>
              <FormattedMessage
                id="landing-global.audience.ai-agents.title"
                defaultMessage="I'm looking for AI Agents"
                tagName={Styled.Title}
              />
              <FormattedMessage
                id="landing-global.audience.ai-agents.description"
                defaultMessage="Deploy your own team of AI Agents and Workflows"
                tagName={Styled.Description}
              />
              <Styled.Cta audience="ai" href={talentHubLinks.aiAgents}>
                <FormattedMessage
                  id="landing-global.audience.ai-agents.cta"
                  defaultMessage="AI Agents"
                  tagName="span"
                />
                <ArrowRoundForwardIcon color={Greyscale.white} />
              </Styled.Cta>
            </Styled.Body>
          </Styled.Card>
        </Styled.Grid>
      </Styled.Inner>
    </Styled.Section>
  );
};

export default AudienceCards;
